// Super admin emails loaded from build-time env vars so they are not
// hardcoded in the shipped bundle. Set REACT_APP_SUPER_ADMIN_EMAILS as a
// comma-separated string in .env (e.g. "admin@example.com,dev@example.com").
const SUPER_ADMIN_EMAILS = (process.env.REACT_APP_SUPER_ADMIN_EMAILS || "")
  .split(",")
  .map((e) => e.trim())
  .filter(Boolean);

export const isSuperAdmin = (user) => {
  if (!user || !user.email) return false;
  return SUPER_ADMIN_EMAILS.includes(user.email);
};

